import { api, formHeaders } from "@";

// Fetches the list of fast donations
export const getFastDonations = () => api.get(`/api/AdminFastDonation/all`);

// Saves a fast donation (creates or updates based on the presence of an id)
export const saveFastDonation = (data) => {

  if (data.id) {
    return api.put(`/api/AdminFastDonation/${data.id}`, data, formHeaders);
  }
  return api.post(`/api/AdminFastDonation`, data, formHeaders);
};
